import { ModalDialog } from "./global";

if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      this.isVariantLoading = false;
      this.currentVariantUrl = null;
      this.hasLoadedVariant = false;
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
       this.selectedSize = null;
      this.hasLoadedVariant = false;
      opener.setAttribute('aria-disabled', true);

      opener.classList.add('loading');
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          this.cleanupForQuickAdd();

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.preventVariantURLSwitching();
          super.show(opener);
          this.callListeners();
          this.listeningForSizeChange(); 
          this.listeningForVariantChange();
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    
    callListeners() {
      this.cleanupForQuickAdd();
      this.listeningForSizeChange();
      this.listeningForVariantChange();
    }

    cleanupForQuickAdd() {
      if (!this.modalContent) return;
      const breadcrumbs = this.modalContent.querySelector(".breadcrumbs");
      if (breadcrumbs) breadcrumbs.remove();
      const packBlock = this.modalContent.querySelectorAll(".packs-block");
      if (packBlock) packBlock.forEach((el) => el.remove());

      this.modalContent.querySelectorAll(".info-accordion__container").forEach((el) => el.remove());
      this.modalContent.querySelectorAll(".color-swatch_badge").forEach((el) => el.remove());
      this.modalContent.querySelectorAll(".modal__toggle").forEach((el) => el.remove());
 
      if (this.selectedSize && this.hasLoadedVariant) {
        let matchedInput = null;
        this.modalContent.querySelectorAll(".product-form__input input").forEach((label) => {
          if (label.value === this.selectedSize && !label.nextElementSibling.className.includes("sold-out")) {
            label.checked = true;
            matchedInput = label;
          }
        });

        if (matchedInput) {
          matchedInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

      }
    }

    listeningForSizeChange() {
      if (this.selectedSize) {
      } else {
        this.selectedSize = null;
      }
      if (!this.modalContent) return;
      this.modalContent.querySelectorAll(".product-form__input input").forEach((label) => {
        label.addEventListener("change", (e) => {
          this.selectedSize = e.target.value;
          this.listeningForVariantChange();
        });
      });
    }

    listeningForVariantChange() {
      if (!this.modalContent) return;
      this.modalContent.querySelectorAll(".product-colors-links label a").forEach((label) => {
        const variantUrl = label.getAttribute("href");
        label.addEventListener("click", (e) => {
          e.preventDefault();
          if (this.isVariantLoading) return;
          if (variantUrl === this.currentVariantUrl) return;
          this.currentVariantUrl = variantUrl;
          this.loadNewVariant(variantUrl);
        });
      });
    }

    loadNewVariant(variantUrl) {
      if (this.isVariantLoading) return;
      this.isVariantLoading = true;
      fetch(variantUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, "text/html");
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
          this.hasLoadedVariant = true;
          this.callListeners();
          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.preventVariantURLSwitching();
        })
        .finally(() => {
          setTimeout(() => {
            this.isVariantLoading = false;
            opener.removeAttribute("aria-disabled");
            opener.classList.remove("loading");
            opener.querySelector(".loading-overlay__spinner").classList.add("hidden");
          }, 80);
        });
    }

    preventVariantURLSwitching() {
      this.modalContent.querySelector('variant-radios,variant-selects').setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
      this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
        variantSelect.dataset.originalSection = sectionId;
      });

 
      this.productElement
        .querySelectorAll('.product-form__input input[name="Size"], .product-form__input input[data-size]')
        .forEach((input) => {
          input.checked = false;
        });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }
  });
}